// FADE TO TOP
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        //check to see if this current container is within viewport
        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
        //else {
        //$element.removeClass('active');
        //}
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
	console.log("ajax complete");
	//so load your lightbox or JS scripts here again
  $('.animated').addClass("active");
});

(function() {

    var s = {

        menuState: function() {

            $(this).toggleClass("cross");
            $(".main-nav-wrapper").toggleClass("open");

        },

        headerHeight: function() {

            if ($(window).scrollTop() > 0) {

                return $('.main-header').height();
            } else {

                return $('.main-header').height() - 24;
            }
        },

        headerPosition: function() {

            var top = $(window).scrollTop();

            if (top > 100) {

                $(".main-header").addClass("min");
                $(".sub-nav").addClass("min");

            } else {

                $(".main-header").removeClass("min");
                $(".sub-nav").removeClass("min");
            }
        },

        events: function() {
            $(window).scroll(this.headerPosition);
            $("#btnMobile").on("click", this.menuState);
        },

        init: function() {

            this.headerPosition();
            this.events();
        }

    };

    s.init();

})();

// ## SUB-MENU NAV ########################################
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    $("ul li ul").removeClass("active");
    $(this).next(".sub-menu").toggleClass("active");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $("ul.sub-menu").removeClass("active");
    }
});

// POPUP
jQuery(document).ready(function(){
  jQuery(".modal-act[href^=#]").click(function(e){
   e.preventDefault();
   $(".modal-wrapper").removeClass("active");
   var href = jQuery(this).attr('href');
   jQuery(href).toggleClass("active");
   $("body").addClass("overflow");
 });
  jQuery(".popup-close").click(function(e){
    e.preventDefault();
    $(".modal-wrapper").removeClass("active");
    $("body").removeClass("overflow");
  });
});

// SCROLL TO ANCHOR PRODUCT
$('a[href^="#"]').not(".nav-link").on('click',function (e) {
    console.log('link-#');
    e.preventDefault();

    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top-140
    }, 1200, 'swing', function () {
        //window.location.hash = target;
    });
});

if (window.location.hash) {
    var hash = window.location.hash;

    if ($(hash).length) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top-140
        }, 900, 'swing');
    }
}

// ## SLIDER ################################################
$(document).ready(function(){
  $('.slideshow .slider-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    cssEase: 'ease',
    fade: true,
    speed: 1000,
  });

  $('.content-repeater-logo .slider-on').slick({
    slidesToShow: 8,
    slidesToScroll: 8,
    autoplay: true,
    autoplaySpeed: 0,
    infinite: true,
    cssEase: 'linear',
    speed: 40000,
    arrows : false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]

  });

  $('.content-testimonials > .content').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    adaptiveHeight: true,
    
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  });

  $('.service-grid-slider > .content').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,

    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  });

});
